module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel2-fr@3x-80856e80b179952c6341587e186786d3.png";